import { LoadSingleStudentFromOtherSchool } from './../../../../ng2/store/actions/single-student-actions';
import { ImStudent } from 'Src/ng2/shared/services/im-models/im-student.service';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LoadSingleStudent } from '../../../../ng2/store/actions/single-student-actions';
import { getCurrentStudent, getStudentLoadedStatus } from '../../../../ng2/store/selectors/student-selector';
@Injectable()
export class StudentListCurrentStudentResolver {
  resolveCurrentStudentForStudentView$(studentId: string, store, schoolId: string): Promise<Observable<any>> {
    const payload = { studentId };
    const destroy$: Subject<boolean> = new Subject<boolean>();
    const isSummerSchoolStudent = ImStudent.prototype.isSummerOnly({ _id: studentId }, schoolId);
    return new Promise(resolve => {
      store
        .select(getStudentLoadedStatus)
        .takeUntil(destroy$)
        .subscribe(studentEntities => {
          if (!studentEntities[studentId]) {
            !isSummerSchoolStudent
              ? store.dispatch(new LoadSingleStudent(payload))
              : store.dispatch(new LoadSingleStudentFromOtherSchool({ ...payload, otherSchoolType: 'summer' }));
          } else {
            const currentStudent$ = store.select(getCurrentStudent, studentId);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(currentStudent$);
          }
        });
    });
  }
}
